import * as React from 'react';
var SelectContext = /*#__PURE__*/React.createContext(null);
export default SelectContext;